<div class="toimittaja-import-container">
  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div class="debug-laatikko">
      <h3>Urit</h3>
      <div>
        Toimittaja-import-doc: <a [href]="toimittajaImportDocLinkkiObservable | async" target="_BLANK">{{ toimittajaImportDocUriObservable | async }}</a>
      </div>
      <div>
        Toimittajat-kollektio (lemonaid): <a [href]="toimittajatCollectionLinkkiObservable | async" target="_BLANK">{{ toimittajatCollectionUriObservable | async }}</a>
      </div>
    </div>
  }

  <mat-tab-group [(selectedIndex)]="aktiivinenTabiIndex" dynamicHeight>
    <mat-tab label="Tuonti">
      <div class="tab-sisalto">
        @if (vaihe === 'idle') {
          <div class="ohje-laatikko">
            <p>Ei valittua tuontitiedostoa. Lataa Netvisorin toimittajarekisteri-XLSX tai Procountorin liikekumppaniraportti-XLS hallintokansioon ja valitse se tuontilähteeksi sieltä.</p>
            <app-primary-button (click)="siirryHallintokansioon()" actionId="Siirry hallintokansioon toimittaja-importia varten"> Siirry hallintokansioon </app-primary-button>
          </div>
        }

        @if (vaihe === 'processing') {
          <div class="processing">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            <p>Käsitellään tiedostoa…</p>
          </div>
        }

        @if (vaihe === 'preview' || vaihe === 'done') {
          @if (tiedostonTiedotObservable | async; as tiedot) {
            <p class="tiedosto-rivi">
              Tiedosto: <strong>{{ tiedot.tiedostonNimi || tiedot.arkistoTiedostonAvain }}</strong>
              @if (tiedot.lahdejarjestelma) {
                <span class="lahde-badge">{{ tiedot.lahdejarjestelma }}</span>
              }
            </p>
          }

          @if (vaihe === 'done' && tallennusTulos) {
            <div class="onnistuminen">
              Tallennettiin <strong>{{ tallennusTulos.tallennetut }}</strong> toimittajaa
              @if (tallennusTulos.ohitetutDuplikaatit > 0) {
                , ohitettiin <strong>{{ tallennusTulos.ohitetutDuplikaatit }}</strong> duplikaattia
              }
              .
            </div>
          }

          @if (rivitObservable | async; as rivit) {
            <div class="taulukko-ylaosa">
              @if (vaihe === 'preview') {
                <p>
                  Esikatselu: <strong>{{ rivit.length }}</strong> riviä. Duplikaatit (sama y-tunnus tai IBAN) suodatetaan automaattisesti tallennusvaiheessa.
                </p>
              }
            </div>
            <div class="taulukko-wrap">
              <table class="toimittaja-taulukko">
                <thead>
                  <tr>
                    <th>Koodi</th>
                    <th>Nimi</th>
                    <th>Y-tunnus</th>
                    <th>IBANit</th>
                  </tr>
                </thead>
                <tbody>
                  @for (rivi of rivit; track rivi.rivinumero) {
                    <tr>
                      <td class="mono">{{ rivi.ulkoinenTunniste }}</td>
                      <td>{{ rivi.nimi }}</td>
                      <td class="mono">{{ rivi.ytunnus }}</td>
                      <td class="mono ibanit-solu">
                        @for (i of rivi.ibanit; track i.iban) {
                          <div>
                            <span [class.oletus-iban]="i.tyyppi === 'oletus'">{{ i.iban }}</span>
                            @if (i.bic) {
                              <span class="bic"> ({{ i.bic }})</span>
                            }
                          </div>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>

            <div class="toiminnot">
              @if (vaihe === 'preview') {
                <app-secondary-button (click)="peruuta()" actionId="Peruuta toimittaja-tuonti">Peruuta</app-secondary-button>
                <div style="flex: 1"></div>
                <app-primary-button (click)="tallenna()" actionId="Tallenna toimittaja-tuonti"> Tallenna {{ rivit.length }} toimittajaa </app-primary-button>
              }
              @if (vaihe === 'done') {
                <div style="flex: 1"></div>
                <app-primary-button (click)="peruuta()" actionId="Aloita uusi toimittaja-tuonti">Tee uusi tuonti</app-primary-button>
              }
            </div>
          }
        }

        @if (vaihe === 'error' && virhe) {
          <div class="virhe-viesti">{{ virhe }}</div>
          <div class="toiminnot">
            <app-secondary-button (click)="peruuta()" actionId="Palaa toimittaja-tuonnin alkuun">Takaisin</app-secondary-button>
            @if (naytaLahdejarjestelmanValinta) {
              <div style="flex: 1"></div>
              <app-primary-button (click)="valitseLahdejarjestelmaJaParsi()" actionId="Valitse toimittaja-tuonnin lähdejärjestelmä">Valitse lähdejärjestelmä</app-primary-button>
            }
          </div>
        }
      </div>
    </mat-tab>

    <mat-tab label="Historia">
      <div class="tab-sisalto">
        @if (historiaObservable | async; as historia) {
          <table class="historia-taulukko">
            <thead>
              <tr>
                <th>Aika</th>
                <th>Lähdejärjestelmä</th>
                <th>Tiedosto</th>
                <th>Lataaja</th>
                <th class="num">Tallennetut</th>
                <th class="num">Duplikaatit</th>
              </tr>
            </thead>
            <tbody>
              @for (entry of historia; track entry.avain) {
                <tr>
                  <td>{{ entry.tuotu?.toDate() | date: 'dd.MM.yyyy HH:mm' }}</td>
                  <td>{{ entry.lahdejarjestelma }}</td>
                  <td>{{ entry.tiedostonNimi || '–' }}</td>
                  <td>{{ annaKayttajanNimi(entry.tuoja, kayttajienNimetMapObservable | async) }}</td>
                  <td class="num">{{ entry.tallennetutToimittajat }}</td>
                  <td class="num">{{ entry.ohitetutDuplikaatit || 0 }}</td>
                </tr>
              }
              @if (historia.length === 0) {
                <tr>
                  <td colspan="6" class="tyhja-rivi">Ei aiempia tuonteja.</td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
